(function() {
  'use strict';

  angular.module('app').factory('CorporateCustomerService', CorporateCustomerService);

  CorporateCustomerService.$inject = ['$rootScope', 'API'];

  function CorporateCustomerService($rootScope, API) {
    var service = {};

    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */

    /**
     * Return corporate customers list of business
     *
     * @param {Object} params - Parameters filter
     * @param {number} params.page - List page number
     * @param {number} params.count - Objects on page
     * @param {'all'|'yes'|'no'} params.suspended - Filter by suspended flag
     * @param {string} params.email - Filter by primary email ID (matching criteria)
     * @param {string} params.search_text - Filter by search string (contains criteria) in main text fields (name, company name, coontacts, etc)
     * @param {string} params.sort - Sort field name
     * @param {'asc'|'desc'} params.order - Sort direction
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.All = function(params, callback) {
      API.get('/corporate_customers?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of corporate customer users ids
     * @param {requestCallback} callback - The callback that handles the response.
     * @param {Object} params - Parameters filter
     */
    service.AllIds = function(params, callback) {
      API.get('/corporate_customers/customers_bulk_ids?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        if (success) {
          callback(success, data);
        }
      });
    };

    /**
     * Card category assign to user account
     */
    service.CardCategoryAssignToUser = function(post_data, callback) {
      API.post('/corporate_customers/categories/assign', post_data, callback);
    };

    /**
     * Add new corporate customer
     *
     * @param {Object} post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddCorporateCustomer = function(post_data, callback) {
      API.post('/corporate_customers', post_data, callback);
    };

    /**
     * Return corporate customer info
     *
     * @param {string} customer_id - Customer ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomer = function(customer_id, callback) {
      API.get('/corporate_customers/' + customer_id, function(success, data) {
        callback(success, data);
      });

    };

    /**
     * Modify corporate customer
     *
     * @param {string} customer_id - Customer ID
     * @param post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateCorporateCustomers = function(customer_id, post_data, callback) {
      API.patch('/corporate_customers/' + customer_id, post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return corporate customers default questionnaire fields
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFields = function(callback) {
      API.get('/corporate_customers/questionnaires/fields', function(success, data) {
        callback(success, data);
      });

    };

    /**
     * Save default questionnaire fields orders
     *
     * @param {Object[]} data - Questionnaire Fields
     * @param {string[]} data[].dictionary_values
     * @param {string} data[].id - Field id
     * @param {MultiLanguageObject} data[].public_description - Some help for user
     * @param {MultiLanguageObject} data[].public_title - Title to show (multi language)
     * @param {number} data[].sort_order - Sort order weight
     * @param {string} data[].title - Field title
     * @param {'string'|'integer'|'money'|'date'|'dictionary'} data[].type - Field type
     * @param {string} data[].value_field_name - Field value key name (readonly)
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFieldsSaveOrders = function(data, callback) {
      API.patch('/corporate_customers/questionnaires/fields', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return default questionnaire field info
     *
     * @param {string} fieldId
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFieldGet = function(fieldId, callback) {
      API.get('/corporate_customers/questionnaires/fields/' + fieldId, function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Add new default questionnaire field
     *
     * @param {Object} data - Questionnaire Field
     * @param {string[]} data.dictionary_values
     * @param {?string} data.id - Field id
     * @param {MultiLanguageObject} data.public_description - Some help for user
     * @param {MultiLanguageObject} data.public_title - Title to show (multi language)
     * @param {number} data.sort_order - Sort order weight
     * @param {string} data.title - Field title
     * @param {'string'|'integer'|'money'|'date'|'dictionary'} data.type - Field type
     * @param {string} data.value_field_name - Field value key name (readonly)
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFieldAdd = function(data, callback) {
      API.post('/corporate_customers/questionnaires/fields', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify default questionnaire field info
     *
     * @param {string} fieldId - Field id
     * @param {Object} data - Questionnaire Field
     * @param {string[]} data.dictionary_values
     * @param {?string} data.id - Field id
     * @param {MultiLanguageObject} data.public_description - Some help for user
     * @param {MultiLanguageObject} data.public_title - Title to show (multi language)
     * @param {number} data.sort_order - Sort order weight
     * @param {string} data.title - Field title
     * @param {'string'|'integer'|'money'|'date'|'dictionary'} data.type - Field type
     * @param {string} data.value_field_name - Field value key name (readonly)
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFieldChange = function(fieldId, data, callback) {
      API.patch('/corporate_customers/questionnaires/fields/' + fieldId, data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Delete default questionnaire field
     *
     * @param {string} fieldId - Field id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CorporateFieldDelete = function(fieldId, callback) {
      API.del('/corporate_customers/questionnaires/fields/' + fieldId, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return corporate customer special accounts
     *
     * @param {string} customerId
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomerSpecialAccounts = function(customerId, callback) {
      API.get('/corporate_customers/' + customerId + '/special_accounts', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return special account for corporate customer
     *
     * @param {string} customerId
     * @param {string} accountId
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomerSpecialAccount = function(customerId, accountId, callback) {
      API.get('/corporate_customers/' + customerId + '/special_accounts/' + accountId, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add special account for corporate customer
     *
     * @param {string} customerId
     * @param {Object} data - CorporateCustomerSpecialAccount
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddCorporateCustomerSpecialAccount = function(customerId, data, callback) {
      API.post('/corporate_customers/' + customerId + '/special_accounts', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add special account for corporate customer
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data - CorporateCustomerSpecialAccount
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.patch('/corporate_customers/' + customerID + '/special_accounts/' + accountID, data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {number} data.amount
     * @param {string} data.comment
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.RefillCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.post('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/refill', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTaxesCorporateCustomerSpecialAccount = function(customerID, accountID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/taxes', function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Return list of tax options for special account
     *
     * @param {string} categoryID - Category ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTaxesCorporateCategoryCustomerSpecialAccount = function(categoryID, accountID, callback) {
      API.get('/corporate_customers/categories/' + categoryID + '/special_accounts/' + accountID + '/taxes', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify and return list of tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTaxesCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.patch('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/taxes', data, function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Modify and return list of tax options for special account
     *
     * @param {string} categoryID - Category ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTaxesCorporateCategoryCustomerSpecialAccount = function(categoryID, accountID, data, callback) {
      API.patch('/corporate_customers/categories/' + categoryID + '/special_accounts/' + accountID + '/taxes', data,
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Return list of items tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {object} params - Parameters
     * @param {string} params.loyalty_id - Item Loyalty Id filter (if needed)
     * @param {boolean} params.only_active - Return only active items objects (if needed)
     * @param {string} params.item_category_id - Item category Id filter (if needed). For root category used 'root' value.
     * @param {string} params.code - Item search by code, cointains criteria (if needed)
     * @param {number} params.page - List page number
     * @param {number} params.count - Objects on page
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTaxesItemsCorporateCustomerSpecialAccount = function(customerID, accountID, params, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID +
          '/taxes/items?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of items tax options for special account
     *
     * @param {string} categoryID - Category ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {object} params - Parameters
     * @param {string} params.loyalty_id - Item Loyalty Id filter (if needed)
     * @param {boolean} params.only_active - Return only active items objects (if needed)
     * @param {string} params.item_category_id - Item category Id filter (if needed). For root category used 'root' value.
     * @param {string} params.code - Item search by code, cointains criteria (if needed)
     * @param {number} params.page - List page number
     * @param {number} params.count - Objects on page
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetTaxesItemsCorporateCategoryCustomerSpecialAccount = function(categoryID, accountID, params, callback) {
      API.get('/corporate_customers/categories/' + categoryID + '/special_accounts/' + accountID +
          '/taxes/items?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify items tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTaxesItemsCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.patch('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/taxes/items', data, function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Modify items tax options for special account
     *
     * @param {string} categoryID - Category ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateTaxesItemsCorporateCategoryCustomerSpecialAccount = function(categoryID, accountID, data, callback) {
      API.patch('/corporate_customers/categories/' + categoryID + '/special_accounts/' + accountID + '/taxes/items', data,
          function(success, data) {
            callback(success, data);
          });
    };
    /**
     * Reset items tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.ResetTaxesItemsCorporateCustomerSpecialAccount = function(customerID, accountID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/taxes/items/reset', function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Reset tax options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.ResetTaxesCorporateCustomerSpecialAccount = function(customerID, accountID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/taxes/reset', function(success, data) {
        callback(success, data);
      });
    };
    /**
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {number} data.amount
     * @param {string} data.comment
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.WriteOffsCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.post('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/write_offs', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {Object} data
     * @param {number} data.amount
     * @param {string} data.comment
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AdjustCorporateCustomerSpecialAccount = function(customerID, accountID, data, callback) {
      API.post('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/adjust', data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return list of price options for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceOptions = function(customerID, accountID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/price_options', function(success, data) {
        callback(success, data);
      });
    };
    /**
     * Add goods item price option for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {object} postData
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddPriceOptions = function(customerID, accountID, postData, callback) {
      API.post('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/price_options', postData
          , function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Delete goods item price option for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {string} itemID - Loyalty item ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeletePriceOptions = function(customerID, accountID, itemID, callback) {
      API.delete('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/price_options/' + itemID, null,
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Get goods item price option for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {string} itemID - Loyalty item ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetPriceOptionsItem = function(customerID, accountID, itemID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/price_options/' + itemID,
          function(success, data) {
            callback(success, data);
          });
    };
    /**
     * Modify goods item price option for special account
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {string} itemID - Loyalty item ID
     * @param {object} postData
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdatePriceOptionsItem = function(customerID, accountID, itemID, postData, callback) {
      API.patch('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/price_options/' + itemID, postData
          , function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Return special account available goods list for corporate customer
     *
     * @param {string} customerID - Corporate customer ID
     * @param {string} accountID - Corporate customer special account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetAvailableGoodsCorporateCustomer = function(customerID, accountID, callback) {
      API.get('/corporate_customers/' + customerID + '/special_accounts/' + accountID + '/goods', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return corporate customers categories
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomersCategories = function(callback) {
      API.get('/corporate_customers/categories', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return corporate customers categories
     *
     * @param {string} categoryID - Category ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomersCategoryById = function(categoryID, callback) {
      API.get('/corporate_customers/categories/' + categoryID, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Add new corporate customers category
     *
     * @param postData - corporate customers category info
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddCorporateCustomersCategories = function(postData, callback) {
      API.post('/corporate_customers/categories', postData, function(success, data) {
        callback(success, data);
      });
    };

    /**
     *  Add new  corporate customers category
     *
     * @param postData - corporate customers category info
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.EditCorporateCustomersCategories = function(postData, callback) {
      API.patch('/corporate_customers/categories/' + postData.id, postData, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return corporate customers categories price info
     *
     * @param {string} params.category_id - Category ID
     * @param {string} params.account_id - Account ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetCorporateCustomersCategoryPriceOptions = function(params, callback) {
      API.get('/corporate_customers/categories/' + params.category_id + '/special_accounts/' + params.account_id + '/price_options',
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Add new corporate customers category
     * @param {string} category_id - Category ID
     * @param {string} account_id - Account ID
     * @param postData - corporate customers category price option
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.AddCorporateCustomersCategoryPriceOptions = function(category_id, account_id, postData, callback) {
      API.post('/corporate_customers/categories/' + category_id + '/special_accounts/' + account_id + '/price_options', postData,
          function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Add new corporate customers category
     * @param {string} category_id - Category ID
     * @param {string} account_id - Account ID
     * @param {string} item_id - Item ID
     * @param postData - corporate customers category price option
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.EditCorporateCustomersCategoryPriceOptions = function(category_id, account_id, item_id, postData, callback) {
      API.patch('/corporate_customers/categories/' + category_id + '/special_accounts/' + account_id + '/price_options/' + item_id,
          postData, function(success, data) {
            callback(success, data);
          });
    };

    /**
     * Add new corporate customers category
     * @param {string} category_id - Category ID
     * @param {string} account_id - Account ID
     * @param {string} item_id - Item ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteCorporateCustomersCategoryPriceOptions = function(category_id, account_id, item_id, callback) {
      API.delete('/corporate_customers/categories/' + category_id + '/special_accounts/' + account_id + '/price_options/' + item_id, {},
          function(success, data) {
            callback(success, data);
          });
    };

    return service;
  }

})();
